import { request, getCompanyId } from '../utils'
import { 
  API_OVERVIEW_METRIC,
  API_OVERVIEW_COST_RATINGS_METRICS,
  API_OVERVIEW_INIT,
  API_OVERVIEW_HEALTH_CHECKS,
  API_NOT_ENABLED_SERVICES,
  API_DENTAL_OVERVIEW,
  API_VISION_OVERVIEW,
  API_OVERVIEW_CONSULTATIONS,
  API_HRA_OVERVIEW,
  API_PRE_EMPLOYMENT_OVERVIEW,
  API_HEALTH_CHALLENGE_OVERVIEW,
  API_WELLNESS_CALENDAR_OVERVIEW,
  API_STEPS_OVERVIEW
} from '../routes/api'

class OverviewApi {
  static fetchOverviewInitData = (options, onSuccess, onError) => {
    return request({ url: API_OVERVIEW_INIT(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchOverviewMetric = (options, onSuccess, onError) => {
    return request({ url: API_OVERVIEW_METRIC(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchOverviewCostAndRatings = (options, onSuccess, onError) => {
    return request({ url: API_OVERVIEW_COST_RATINGS_METRICS(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchHealthChecksOverview = (options, onSuccess, onError) => {
    return request({ url: API_OVERVIEW_HEALTH_CHECKS(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchConsultationsOverview = (options, onSuccess, onError) => {
    return request({ url: API_OVERVIEW_CONSULTATIONS(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchDentalOverview = (options, onSuccess, onError) => {
    return request({ url: API_DENTAL_OVERVIEW(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchVisionOverview = (options, onSuccess, onError) => {
    return request({ url: API_VISION_OVERVIEW(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchHraOverview = (options, onSuccess, onError) => {
    return request({ url: API_HRA_OVERVIEW(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchHealthChallengeOverview = (options, onSuccess, onError) => {
    return request({ url: API_HEALTH_CHALLENGE_OVERVIEW(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchPreEmploymentOverview = (options, onSuccess, onError) => {
    return request({ url: API_PRE_EMPLOYMENT_OVERVIEW(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchWellnessCalendarOverview = (options, onSuccess, onError) => {
    return request({ url: API_WELLNESS_CALENDAR_OVERVIEW(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }
  
  static fetchStepsOverview = (options, onSuccess, onError) => {
    return request({ url: API_STEPS_OVERVIEW(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError)
  }

  static fetchNotEnabledServices(options, onSuccess, onError) {
    return request({ url: API_NOT_ENABLED_SERVICES(options.contract_id, options.start_date, options.end_date) + '&' + getCompanyId(true), ...options }, onSuccess, onError);
  }
}

export default OverviewApi